import { createFileRoute } from '@tanstack/react-router';
import { ScrollTextIcon } from 'lucide-react';
import { MilestoneScreen } from '@/components/milestone-screen';

function AuditLogPage() {
  return (
    <MilestoneScreen
      eyebrow="Operations"
      title="Audit log"
      description="An append-only record of who did what in this organisation, and from where."
      icon={ScrollTextIcon}
      milestone="Milestone 9"
      scope={[
        'Filter by actor, action, resource and date range across users, API keys and system jobs.',
        'Inspect the metadata captured with each event, including the originating request ID.',
        'Export a range to CSV where the plan includes audit export.',
        'Entries are immutable — the log is evidence, not editable state.',
      ]}
    />
  );
}

export const Route = createFileRoute('/app/$orgId/audit-log')({
  component: AuditLogPage,
});
